import { memo, useEffect, useMemo, useState } from "react";
import CategorySelect from "./CategorySelect";

const ServiceCatalogPanel = ({
  categories = [],
  selectedCategory,
  categoriesLoading,
  categoryError,
  services = [],
  loading,
  servicesError,
  onCategoryChange,
  onAddService,
}) => {
  const [selectedServiceId, setSelectedServiceId] = useState("");

  const selectedService = useMemo(
    () => services.find((service) => service.id === selectedServiceId) || null,
    [selectedServiceId, services],
  );

  useEffect(() => {
    setSelectedServiceId(services[0]?.id || "");
  }, [services]);

  const handleAddSelectedService = () => {
    if (!selectedService) return;
    onAddService?.(selectedService);
  };

  const serviceSelectDisabled =
    !selectedCategory ||
    Boolean(categoryError) ||
    Boolean(servicesError) ||
    services.length === 0;

  return (
    <section className="w-full rounded-[16px] bg-[#F9F9F9] p-0 md:p-4">
      <div className="flex flex-col gap-3">
        <div className="min-w-0">
          <h2 className="text-xl font-bold text-gray-800">Danh Sách Dịch Vụ</h2>
        </div>

        <div className="grid gap-3 lg:grid-cols-[minmax(220px,320px)_minmax(280px,560px)_auto] lg:items-end lg:justify-start">
          <div className="w-full max-w-[560px]">
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Loại dịch vụ
            </label>
            <CategorySelect
              value={selectedCategory?.id}
              options={categories}
              loading={categoriesLoading}
              disabled={Boolean(categoryError)}
              placeholder="Chọn loại dịch vụ"
              ariaLabel="Chọn loại dịch vụ"
              onChange={onCategoryChange}
            />
          </div>

          <div className="w-full">
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Danh sách dịch vụ
            </label>
            <CategorySelect
              value={selectedServiceId}
              options={services}
              loading={loading}
              disabled={serviceSelectDisabled}
              placeholder={servicesError || "Chọn dịch vụ"}
              ariaLabel="Chọn dịch vụ"
              onChange={(service) => setSelectedServiceId(service.id)}
            />
          </div>

          <button
            type="button"
            onClick={handleAddSelectedService}
            disabled={!selectedService || loading}
            className="h-11 rounded-lg bg-[#0267FF] px-5 text-sm font-semibold text-white transition-colors hover:bg-[#0057D9] disabled:cursor-not-allowed disabled:bg-gray-300"
          >
            Thêm dịch vụ
          </button>
        </div>

        {categoryError && (
          <p className="text-sm text-red-600">{categoryError}</p>
        )}
        {!categoryError &&
          selectedCategory &&
          !loading &&
          services.length === 0 && (
            <p className="text-sm text-gray-500">Không có dịch vụ con nào</p>
          )}
      </div>
    </section>
  );
};

export default memo(ServiceCatalogPanel);
